module.exports = __webpack_public_path__ + "03_glasses_red.07e0647e.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/papa/layer4/03_glasses_red.png
// module id = a85V
// module chunks = 0